import { useMemo } from 'react'
import { ChatChannelInstance, ChatMember } from "../types";
import { BaseChatPackage, isChatGroup } from "../utils";
import { ReactQuery } from '@codeleap/query'
import { useChatEventsDebounced } from './useChatEventsDebounced';

export class UseGroupDescription extends BaseChatPackage {
  useGroupDescription(channel: ChatChannelInstance, maxMembers = 5) {
    const isGroup = isChatGroup(channel)

    const membersQuery = ReactQuery.useQuery({
      queryFn: async () => {
        const response = await this.chatApi.listMembers(channel.id, { limit: maxMembers + 1, include_me: true })
        if (response.ok) return response?.data?.results
        return null
      },
      queryKey: ['groupDescription', channel.id],
      enabled: !!channel?.id && isGroup,
      staleTime: 0,
      gcTime: 0,
    })

    useChatEventsDebounced({
      channel, 
      events: [
      { type: 'member.updated', callback: membersQuery.refetch },
      { type: 'member.added', callback: membersQuery.refetch },
      { type: 'member.removed', callback: membersQuery.refetch },
    ]})

    const items = membersQuery?.data || []

    const groupDescription = useMemo(() => {
      if (!isGroup || !items|| items?.length === 0) {
        return undefined
      }

      const totalMembers = items.length
      const hasMore = totalMembers > maxMembers
      const memberParts: string[] = []

      items.forEach((member: ChatMember) => {
        const user = member.user as any
        const name = user?.name

        if (memberParts?.length < maxMembers && name) {
          memberParts.push(name)
        }
      })

      if (memberParts.length === 0) {
        return undefined
      }

      let text = memberParts.join(', ')

      if (hasMore) {
        text += ', +...'
      }

      return text
    }, [isGroup, items])


    return { membersQuery, groupDescription }
  }
}


